// extracted by mini-css-extract-plugin
export var breadcrumb = "_1m-0";
export var breadcrumbArrow = "_1m-1";